// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Экран 15 «Настройки» (утверждён 28.10.2026). */
.ac-grid {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}
.ac-nav {
  flex: none;
  width: 190px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: sticky;
  top: 72px;
}
.ac-nav button {
  text-align: left;
  border: 1px solid transparent;
  background: none;
  font: inherit;
  font-size: 14px;
  padding: 9px 12px;
  border-radius: 10px;
  cursor: pointer;
  color: var(--v2-text-2);
}
.ac-nav button.is-on {
  background: #fff;
  border-color: var(--v2-border);
  font-weight: 600;
  color: var(--v2-primary);
}
.ac-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.ac-card {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  scroll-margin-top: 72px;
}
.ac-two {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
}
.ac-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ac-field > span:first-child {
  font-weight: 600;
  font-size: 13px;
}
.ac-field input[readonly] {
  background: var(--v2-bg);
  color: var(--v2-text-2);
}
.st-input.is-err {
  border-color: #dc2626;
}
.ac-notif-head {
  display: grid;
  grid-template-columns: 1fr 60px;
  text-align: center;
  border-bottom: 1px solid var(--v2-border-soft);
  padding-bottom: 6px;
}
.ac-notif {
  display: grid;
  grid-template-columns: 1fr 60px;
  align-items: center;
  border-bottom: 1px solid var(--v2-border-soft);
  padding: 10px 0;
}
.ac-notif input[type='checkbox'] {
  justify-self: center;
  width: 18px;
  height: 18px;
}
.ac-notif-title {
  font-weight: 600;
}
.ac-thr {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 4px;
}
.st-input.ac-thr-input {
  width: 96px;
  height: 32px;
}
.ac-card.ac-sec {
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.ac-pw {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (max-width: 900px) {
  .ac-grid {
    flex-direction: column;
  }
  .ac-nav {
    position: static;
    width: auto;
    flex-direction: row;
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/account/account.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":["/* Экран 15 «Настройки» (утверждён 28.10.2026). */\n.ac-grid {\n  display: flex;\n  gap: 18px;\n  align-items: flex-start;\n}\n.ac-nav {\n  flex: none;\n  width: 190px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  position: sticky;\n  top: 72px;\n}\n.ac-nav button {\n  text-align: left;\n  border: 1px solid transparent;\n  background: none;\n  font: inherit;\n  font-size: 14px;\n  padding: 9px 12px;\n  border-radius: 10px;\n  cursor: pointer;\n  color: var(--v2-text-2);\n}\n.ac-nav button.is-on {\n  background: #fff;\n  border-color: var(--v2-border);\n  font-weight: 600;\n  color: var(--v2-primary);\n}\n.ac-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.ac-card {\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  scroll-margin-top: 72px;\n}\n.ac-two {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 14px;\n}\n.ac-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.ac-field > span:first-child {\n  font-weight: 600;\n  font-size: 13px;\n}\n.ac-field input[readonly] {\n  background: var(--v2-bg);\n  color: var(--v2-text-2);\n}\n.st-input.is-err {\n  border-color: #dc2626;\n}\n.ac-notif-head {\n  display: grid;\n  grid-template-columns: 1fr 60px;\n  text-align: center;\n  border-bottom: 1px solid var(--v2-border-soft);\n  padding-bottom: 6px;\n}\n.ac-notif {\n  display: grid;\n  grid-template-columns: 1fr 60px;\n  align-items: center;\n  border-bottom: 1px solid var(--v2-border-soft);\n  padding: 10px 0;\n}\n.ac-notif input[type='checkbox'] {\n  justify-self: center;\n  width: 18px;\n  height: 18px;\n}\n.ac-notif-title {\n  font-weight: 600;\n}\n.ac-thr {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n}\n.st-input.ac-thr-input {\n  width: 96px;\n  height: 32px;\n}\n.ac-card.ac-sec {\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n}\n.ac-pw {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n@media (max-width: 900px) {\n  .ac-grid {\n    flex-direction: column;\n  }\n  .ac-nav {\n    position: static;\n    width: auto;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
